import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { SequenceCounter, SequenceCounterCreate, SequenceCounterFilter } from '../data/sequenceCounter';

export function createSequenceCounterService(client: AxiosInstance) {
  return createCrudService<SequenceCounter, SequenceCounterCreate, SequenceCounterFilter>(
    client,
    '/platform/SequenceCounter',
    'id',
  );
}

export type SequenceCounterService = CrudService<SequenceCounter, SequenceCounterCreate, SequenceCounterFilter>;
